export const bindStoryChrome = (onChange) => {
  let shown = true
  let skip = false
  let skipTimer = 0
  let lastTop = 0
  let touchY = null

  const setShown = (show) => {
    if (show === shown) return
    shown = show
    skip = true
    onChange(show)
    window.clearTimeout(skipTimer)
    skipTimer = window.setTimeout(() => { skip = false }, 450)
  }

  return {
    onScroll(node) {
      if (!node || skip) return
      const top = node.scrollTop
      const delta = top - lastTop
      lastTop = top
      if (delta > 4) setShown(false)
      else if (delta < -4) setShown(true)
    },
    onWheel(event) {
      if (event.deltaY > 5) setShown(false)
      else if (event.deltaY < -5) setShown(true)
    },
    onTouchStart(event) {
      touchY = event.touches[0].clientY
    },
    onTouchMove(event) {
      if (touchY == null) return
      const dy = touchY - event.touches[0].clientY
      if (dy > 6) setShown(false)
      else if (dy < -6) setShown(true)
    },
    reset(show = true) {
      lastTop = 0
      setShown(show)
    },
    destroy() {
      window.clearTimeout(skipTimer)
    }
  }
}
